import { llmStatsQuery, sitesQuery } from '@/api/queries'
import { LlmUsage } from '@/components/llm/LlmUsage'
import { ErrorCard, LoadingCard } from '@/components/ui/StateCards'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { z } from 'zod'
import { t } from '@/lib/i18n'

const llmSearchSchema = z.object({
  from: z.string().optional(),
  to: z.string().optional(),
})

export const Route = createFileRoute('/llm')({
  validateSearch: llmSearchSchema,
  component: LlmRoute,
})

function LlmRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: '/llm' })
  const from = search.from ?? null
  const to = search.to ?? null
  const query = useQuery(llmStatsQuery(from, to))
  // 19 Oct 2026: show site names, not ids.
  const sites = useQuery(sitesQuery)
  const siteNames = Object.fromEntries((sites.data?.sites ?? []).map((s) => [s.id, s.name]))

  if (query.isPending) return <LoadingCard label={t('Loading AI cost…')} />
  if (query.isError) return <ErrorCard message={query.error.message} onRetry={query.refetch} />

  return (
    <LlmUsage
      data={query.data}
      from={from}
      to={to}
      onChangeRange={(next) => navigate({ search: next })}
      siteNames={siteNames}
    />
  )
}
